import React from "react"
import { AdminLayout } from "../../../shared/components/layout/admin/AdminLayout"

export function AdminDashboard() {
    return <AdminLayout>Admin Dashboard</AdminLayout>;
}